import React, { useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

import {
  LOGIN_AND_CLOSE_URL,
  HTTP_RESPONSE_STATUS_FORBIDDEN_IN_THIS_MONTH,
} from "../../../config";
import { getWavewormData } from "../../../api/fdsnws";
import { getQc } from "../../../api/kquakeQc";
import { getLoginStatus } from "../../../api/sso";

import { setLoginStatus } from "../../../store/userSlice";
import { selectAllStations } from "../../../store/stationsSlice";
import {
  StationFilterContext,
  stationFilterDefaultState,
  stationFilterReducer,
  selectStations,
} from "../../../contexts/StationFilterContext";
import {
  ChannelFilterContext,
  channelFilterDefaultState,
  channelFilterReducer,
  selectChannels,
  selectOneChannelPerSensor,
} from "../../../contexts/ChannelFilterContext";
import {
  TimeWindowSelectorContext,
  timeWindowSelectorDefaultState,
  timeWindowSelectorReducer,
  getTimeWindowApiFilter,
} from "../../../contexts/TimeWindowSelectorContext";

import { StationSelectorFormSimple } from "../../forms/StationSelectorFormSimple";
import { ChannelSelectorForm } from "../../forms/ChannelSelectorForm";
import { TimeWindowSelectorForm } from "../../forms/TimeWindowSelectorForm";

import { SelectedChannelsModal } from "../../modals/SelectedChannelsModal";
import { DataAvailabilityModal } from "../../modals/DataAvailabilityModal";
import { LoadingScreen } from "../../LoadingScreen";

const PRUPOSES_OF_USE = [
  "study_natural_science",
  "study_engineering",
  "seismic_desing",
  "educational",
  "etc",
];

const getFileExtentionFromFormat = (format) => {
  return format === "geocsv" ? "csv" : format;
};

export const ContinuousData = () => {
  const stations = useSelector(selectAllStations);
  const isLoggedIn = useSelector((state) => state.user.login);
  const apiToken = useSelector((state) => state.user.apiToken);

  const [stationFilter, dispatchStationFilter] = useReducer(
    stationFilterReducer,
    stationFilterDefaultState
  );
  const [channelFilter, dispatchChannelFilter] = useReducer(
    channelFilterReducer,
    channelFilterDefaultState
  );
  const [timeWindowSelector, dispatchTimeWindowSelector] = useReducer(
    timeWindowSelectorReducer,
    timeWindowSelectorDefaultState
  );

  const [selectedChannels, setSelectedChannels] = useState([]);
  const [streamAvailabilities, setStreamAvailabilities] = useState([]);

  const [showSelectedChannelsModal, setShowSelectedChannelsModal] =
    useState(false);
  const [showDataAvailabilityModal, setShowDataAvailabilityModal] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [downloadFormat, setDownloadFormat] = useState("mseed");
  const [downloadPurpose, setDownloadPurpose] = useState();

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showSelectedChannels = () => {
    let selectedStations = [];
    let selectedChannels = [];

    console.log("showSelectedChannels: stationFilter =", stationFilter);
    console.log("showSelectedChannels: channelFilter =", channelFilter);

    try {
      selectedStations = selectStations(stations, stationFilter);
    } catch (error) {
      alert(
        t("form.message.errorInStation") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }

    if (selectedStations.length === 0) {
      alert(t("form.message.noStations"));
    } else {
      try {
        selectedChannels = selectChannels(selectedStations, channelFilter);
      } catch (error) {
        alert(
          t("form.message.errorInChannel") +
            "\r\n" +
            t("form.message." + error.message)
        );
        return;
      }
    }
    setSelectedChannels(selectedChannels);
    if (selectedChannels.length === 0) {
      alert(t("form.message.noChannels"));
    } else {
      setShowSelectedChannelsModal(true);
    }
  };

  const showDataAvailability = async () => {
    let apiQuery = {};
    let selectedStations = [];
    let selectedChannels = [];

    // console.log('showDataAvailability: stationFilter =', stationFilter)
    // console.log('showDataAvailability: channelFilter =', channelFilter)
    // console.log('showDataAvailability: timeWindowSelector =', timeWindowSelector)

    try {
      apiQuery = getTimeWindowApiFilter(timeWindowSelector);
    } catch (error) {
      alert(
        t("form.message.errorInDataTime") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }

    try {
      selectedStations = selectStations(stations, stationFilter);
    } catch (error) {
      alert(
        t("form.message.errorInStation") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }
    if (selectedStations.length === 0) {
      alert(t("form.message.noStations"));
      return;
    }

    try {
      // selectedChannels = selectOneChannelPerSensor(
      selectedChannels = selectChannels(selectedStations, channelFilter);
      console.log("selectedChannels", selectedChannels);
    } catch (error) {
      alert(`${t("form.message.errorInChannel")}\r\n${error.message}`);
      return;
    }
    if (selectedChannels.length === 0) {
      alert(t("form.message.noChannels"));
      setStreamAvailabilities([]);
      return;
    }

    setIsLoading(true);
    let responseData = {};
    try {
      responseData = await getQc(
        apiQuery.start,
        apiQuery.end,
        selectedChannels.map(({ streamId }) => streamId)
      );
    } catch (error) {
      setIsLoading(false);
      const alertMessage = [
        t("form.message.failedToFetchAvailabilit"),
        `Error message: ${error.message}`,
        t("form.message.contactAdministrator"),
      ];
      alert(alertMessage.join("\r\n"));
      return;
    }
    setIsLoading(false);

    const streamAvailabilities = selectedChannels.map((channel) => ({
      ...channel,
      availability: responseData[channel.streamId].availability,
      timingQuality: responseData[channel.streamId].timing,
      massPosition: responseData[channel.streamId].mass,
      qcIndex: responseData[channel.streamId].index,
    }));
    setStreamAvailabilities(streamAvailabilities);
    setShowDataAvailabilityModal(true);
  };

  const downloadData = async () => {
    let apiQuery = {};
    let selectedStations = [];
    let selectedChannels = [];

    // console.log('showDataAvailability: stationFilter =', stationFilter)
    // console.log('showDataAvailability: channelFilter =', channelFilter)
    // console.log('showDataAvailability: timeWindowSelector =', timeWindowSelector)

    try {
      apiQuery = getTimeWindowApiFilter(timeWindowSelector);
    } catch (error) {
      alert(
        t("form.message.errorInDataTime") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }

    try {
      selectedStations = selectStations(stations, stationFilter);
    } catch (error) {
      alert(
        t("form.message.errorInStation") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }
    if (selectedStations.length === 0) {
      alert(t("form.message.noStations"));
      return;
    }

    try {
      selectedChannels = selectChannels(selectedStations, channelFilter);
    } catch (error) {
      alert(
        t("form.message.errorInChannel") +
          "\r\n" +
          t("form.message." + error.message)
      );
      return;
    }
    if (selectedChannels.length === 0) {
      alert(t("form.message.noChannels"));
      return;
    }

    if (!downloadFormat) {
      alert(t("form.message.selectDataFormat"));
      return;
    }
    if (!downloadPurpose) {
      alert(t("form.message.selectPurpose"));
      return;
    }

    let logInStatus = {};
    if (!isLoggedIn) {
      setIsLoading(true);
      logInStatus = await getLoginStatus();
      if (logInStatus?.status === 200) {
        dispatch(setLoginStatus({ ...logInStatus }));
      }
      setIsLoading(false);
    }

    if (!isLoggedIn && logInStatus?.status !== 200) {
      if (window.confirm(t("form.message.clickDownloadAfterLogin"))) {
        const loginWindow = window.open(LOGIN_AND_CLOSE_URL, "_blank");
        if (loginWindow) {
          loginWindow.focus();
        }
      }
      return;
    }

    const _apiToken =
      logInStatus?.status === 200 ? logInStatus.token : apiToken;
    setIsLoading(true);
    const response = await getWavewormData(
      downloadFormat,
      downloadPurpose,
      apiQuery.start,
      apiQuery.end,
      selectedChannels.map(({ streamId }) => streamId),
      _apiToken
    );
    if (response.status === 200) {
      // let fileName
      // const disposition = response.headers.get("content-disposition")
      // console.log(disposition)
      // if (disposition) {
      //   fileName = disposition.split("filename=")[1];
      // }
      const extention = getFileExtentionFromFormat(downloadFormat);
      const fileName = `kquake_waveform_${timeWindowSelector.startTime.replace(
        /[\s-/:]/g,
        ""
      )}.${extention}`;
      const blob = await response.blob();
      setIsLoading(false);
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.setAttribute("download", fileName);
      a.click();
    } else {
      setIsLoading(false);
      if (response.status === 204) {
        alert(
          t("form.message.noDataToDownload") +
            "\r\n" +
            t("form.message.checkAvailability")
        );
      } else if (response.status === 401) {
        alert(t("form.message.authenticationFailedRefresh"));
      } else if (
        response.status === HTTP_RESPONSE_STATUS_FORBIDDEN_IN_THIS_MONTH
      ) {
        alert(t("form.message.downloadCapacityExceeded"));
      } else {
        const alertMessage = [
          t("form.message.failedToDownload"),
          `Error message:${response.statusText}`,
          t("form.message.contactAdministrator"),
        ];
        alert(alertMessage.join("\r\n"));
      }
    }
  };

  return (
    <div className="container">
      <div className="sub-container">
        {/* <div className="alert alert-danger"><i className="ion ion-md-information-circle-outline"></i> 로그인이 필요한 서비스입니다. </div> */}
        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
          &nbsp;&nbsp;<i className="ion ion-md-help-circle-outline"></i>
          {t("page.continuous-data.desc")}
        </div>
        <div className="overflow-auto">
          <table className="datatable mb20">
            <colgroup>
              <col style={{ width: "20%" }} />
              <col style={{ width: "80%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th className="first">{t("w.station")}</th>
                <td className="first">
                  <StationFilterContext.Provider
                    value={{
                      state: stationFilter,
                      dispatch: dispatchStationFilter,
                    }}
                  >
                    <StationSelectorFormSimple />
                  </StationFilterContext.Provider>
                </td>
              </tr>
              <tr>
                <th>{t("w.channel")}</th>
                <td className="pr0">
                  <ChannelFilterContext.Provider
                    value={{
                      state: channelFilter,
                      dispatch: dispatchChannelFilter,
                    }}
                  >
                    <ChannelSelectorForm />
                  </ChannelFilterContext.Provider>
                  <div>
                    <a
                      className="waves-effect waves-light button-sm modal-trigger"
                      onClick={showSelectedChannels}
                    >
                      {t("form.channel.showSelectedChannels")}
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{t("form.dataTime")}</th>
                <td>
                  <TimeWindowSelectorContext.Provider
                    value={{
                      state: timeWindowSelector,
                      dispatch: dispatchTimeWindowSelector,
                    }}
                  >
                    <TimeWindowSelectorForm />
                  </TimeWindowSelectorContext.Provider>
                  <br />
                  <br />
                  <div className="text-muted lh20 lheight29">
                    &nbsp;&nbsp;
                    <i className="ion ion-md-information-circle-outline"></i>
                    &nbsp;{t("page.continuous-data.serviceDesc.1")} <br />
                    &nbsp;&nbsp;
                    <i className="ion ion-md-information-circle-outline"></i>
                    &nbsp;{t("page.continuous-data.serviceDesc.2")} <br />
                    &nbsp;&nbsp;
                    <i className="ion ion-md-information-circle-outline"></i>
                    &nbsp;{t("page.continuous-data.serviceDesc.3")} <br />
                    &nbsp;&nbsp;
                    <i className="ion ion-md-information-circle-outline"></i>
                    &nbsp;
                    <Trans
                      i18nKey="page.continuous-data.serviceDesc.4"
                      components={{ link1: <Link to="/openapi/fdsnws" /> }}
                    />
                    <br />
                    &nbsp;&nbsp;
                    <i className="ion ion-md-information-circle-outline"></i>
                    &nbsp;
                    <Trans
                      i18nKey="page.continuous-data.serviceDesc.5"
                      components={{
                        link1: (
                          <a
                            href="https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/manuals/QC-Index_manual_latest.pdf"
                            target="_blank "
                          />
                        ),
                      }}
                    />
                    <br />
                  </div>
                  <div className="inline-block">
                    <a
                      className="waves-effect waves-light button-sm modal-trigger"
                      onClick={showDataAvailability}
                    >
                      {t("page.continuous-data.showDataAvailability")}
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="dataselect_box">
          <span className="txt_title">{t("w.dataFormat")}</span>
          <form className="inline-block">
            <label htmlFor="selectEventRecord.downloadFormat.mseed">
              <input
                type="radio"
                id="selectEventRecord.downloadFormat.mseed"
                className="with-gap"
                checked={downloadFormat === "mseed"}
                onChange={(e) => {
                  if (e.target.checked) setDownloadFormat("mseed");
                }}
              />
              <span>miniSEED</span>
            </label>
            <label htmlFor="selectEventRecord.downloadFormat.sac">
              <input
                type="radio"
                id="selectEventRecord.downloadFormat.sac"
                className="with-gap"
                checked={downloadFormat === "sac.zip"}
                onChange={(e) => {
                  if (e.target.checked) setDownloadFormat("sac.zip");
                }}
              />
              <span>SAC</span>
            </label>
            <label htmlFor="selectEventRecord.downloadFormat.geocsv">
              <input
                type="radio"
                id="selectEventRecord.downloadFormat.geocsv"
                className="with-gap"
                checked={downloadFormat === "geocsv.zip"}
                onChange={(e) => {
                  if (e.target.checked) setDownloadFormat("geocsv.zip");
                }}
              />
              <span>GeoCSV (ASCII)</span>
            </label>
          </form>
        </div>
        <div className="dataselect_box">
          <span className="txt_title">{t("w.purposeOfUse")}</span>
          <form className="inline-block">
            {PRUPOSES_OF_USE.map((purpose) => (
              <label key={purpose}>
                <input
                  className="with-gap"
                  name="dataformat"
                  type="radio"
                  checked={downloadPurpose === purpose}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setDownloadPurpose(purpose);
                    }
                  }}
                />
                <span>{t("purposeOfUse." + purpose)}</span>
              </label>
            ))}
          </form>
        </div>

        <div className="center-align row">
          {/* <form method="get" action="./data/_sample-img-5.zip"> */}
          <button
            className="btn-block waves-effect waves-light button-lg"
            onClick={downloadData}
          >
            {t("w.download")}
          </button>
          {/* </form> */}
        </div>
      </div>
      {showSelectedChannelsModal && (
        <SelectedChannelsModal
          selectedChannels={selectedChannels}
          onClose={() => setShowSelectedChannelsModal(false)}
        />
      )}
      {showDataAvailabilityModal && (
        <DataAvailabilityModal
          streamAvailabilities={streamAvailabilities}
          onClose={() => setShowDataAvailabilityModal(false)}
        />
      )}
      <LoadingScreen screen={isLoading} />
    </div>
  );
};
